// extracted by mini-css-extract-plugin
module.exports = {"divider":"PostMeta_divider__O8n5R","container":"PostMeta_container__yseBI","postMetaList":"PostMeta_postMetaList__9SBMx"};